import React, { useEffect, useState } from "react";
import { Search, Dropdown } from "semantic-ui-react";

import CardProduct from "../../components/Card/CardProduct";

import HttpService from "../../HttpService";
import _ from "lodash";

const ComparePackage = ({ location }) => {
  const [packageList, setPacakgeList] = useState([]);
  const [specShow, setSpecShow] = useState({
    free_sms: "",
    free_on_net_minutes: "",
    free_off_net_minutes: "",
    validity: "",
    free_mbs: "",
  });
  const [selectedPackage, setSelectedPackage] = useState([]);
  const [selectedPackageLoading, setSelectedPacakgeLoading] = useState(false);
  const [packageOptions, setPackageOptions] = useState([]);
  const [error, setError] = useState(null);
  const [value, setValue] = useState("");
  const [packageListLoading, setPackageListLoading] = useState(false);

  useEffect(() => {
    const fetchPackages = async () => {
      setError(false);

      try {
        setPackageListLoading(true);

        const pacakgeList = await HttpService.get("/packages");

        setPackageOptions(
          pacakgeList.data.packages.map((packagee) => ({
            title: packagee.company_name.name,
            description: "description",
            // packageName: packagee.package_name,
            image: packagee.image,
            price: `Price : ${packagee.price}`,
            details: packagee.details,
            _id: packagee._id,
            key: packagee._id,
          }))
        );
      } catch (error) {
        setError(true);
      }
      setPackageListLoading(false);

      if (
        location &&
        location.state &&
        location.state.packages &&
        selectedPackage.length === 0
      ) {
        let packages = [];

        packages = [...selectedPackage];
        packages[0] = location.state.packages;
        setSelectedPackage(packages);
      }
    };

    fetchPackages();
  }, [location, selectedPackage]);

  const handleSearchChange = (e, { value }) => {
    setTimeout(() => {
      if (value.length < 1) {
        setValue(value);
        setPacakgeList([]);
      }
      const re = new RegExp(_.escapeRegExp(value), "i");
      const isMatch = (result) => re.test(result.title);
      setPacakgeList(_.filter(packageOptions, isMatch));
    }, 300);
  };

  const handleResultSelect = async (e, data) => {
    let packages = [];

    const packag = await HttpService.get(`/package/${data.result._id}`);

    packages = selectedPackage ? [...selectedPackage] : [];
    packages[data.index] = packag.data[0];

    setSelectedPackage(packages);
  };

  const getRows = (spec, specType) => {
    let rows = [];

    for (let i = 0; i <= 3; i++) {
      const row = (
        <>
          <td className="spec_table_border" key={i}>
            {selectedPackage &&
              selectedPackage[i] &&
              selectedPackage[i].details &&
              selectedPackage[i].details[spec]}
          </td>
        </>
      );
      rows.push(row);
    }
    return rows;
  };
  const closeCard = (index) => {
    let packages = [];

    packages = [...selectedPackage];
    packages.splice(index, 1);

    setSelectedPackage(packages);
  };

  const closeSpecList = (spec) => {
    let status = "none";
    if (specShow[spec] === "none") {
      status = "";
    }
    setSpecShow((prevState) => ({
      ...prevState,
      [spec]: status,
    }));
  };

  return (
    <React.Fragment>
      <section className="product-details">
        <div className="container">
          <div className="row compare-folding-section">
            <div className="col-12 text-center">
              <h2 className="compare-folding-title">Compare your Package</h2>
            </div>
          </div>
          <div className="row compare-products">
            <div className="col-12">
              <table className="p0 table table-responsive">
                <tbody>
                  <tr>
                    <td className="spec_table_border">
                      <div className="choose-market text-center">
                        <div className="compare-product-add">
                          <i
                            className="fa fa-hand-o-right"
                            aria-hidden="true"
                          ></i>
                          <h6 className="compare-product-tile">
                            Compare product
                          </h6>
                          <p>
                            <u>{`${
                              selectedPackage && selectedPackage.length
                            } package added`}</u>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="spec_table_border">
                      {selectedPackage &&
                      selectedPackage[0] &&
                      selectedPackage[0] ? (
                        <CardProduct
                          image={selectedPackage[0] && selectedPackage[0].image}
                          price={selectedPackage[0] && selectedPackage[0].price}
                          title={
                            selectedPackage[0] &&
                            selectedPackage[0].company_name.name
                          }
                          index={0}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={packageListLoading}
                            index={0}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Add to Compare"
                            results={packageList}
                          />
                        </div>
                      )}
                    </td>
                    <td className="spec_table_border">
                      {selectedPackage &&
                      selectedPackage[1] &&
                      selectedPackage[1] ? (
                        <CardProduct
                          image={selectedPackage[1] && selectedPackage[1].image}
                          price={selectedPackage[1] && selectedPackage[1].price}
                          title={
                            selectedPackage[1] &&
                            selectedPackage[1].company_name.name
                          }
                          index={1}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={packageListLoading}
                            index={1}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Add to Compare"
                            results={packageList}
                          />
                        </div>
                      )}
                    </td>
                    <td className="spec_table_border">
                      {selectedPackage &&
                      selectedPackage[2] &&
                      selectedPackage[2] ? (
                        <CardProduct
                          image={selectedPackage[2] && selectedPackage[2].image}
                          price={selectedPackage[2] && selectedPackage[2].price}
                          title={
                            selectedPackage[2] &&
                            selectedPackage[2].company_name.name
                          }
                          index={2}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={packageListLoading}
                            index={2}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Add to Compare"
                            results={packageList}
                          />
                        </div>
                      )}
                    </td>
                    <td className="spec_table_border">
                      {selectedPackage &&
                      selectedPackage[3] &&
                      selectedPackage[3] ? (
                        <CardProduct
                          image={selectedPackage[3] && selectedPackage[3].image}
                          price={selectedPackage[3] && selectedPackage[3].price}
                          title={
                            selectedPackage[3] &&
                            selectedPackage[3].company_name.name
                          }
                          index={3}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={packageListLoading}
                            index={3}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Add to Compare"
                            results={packageList}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                  {selectedPackage.length > 0 ? (
                    <>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("specs")}
                          >
                            <i className="collapse"></i>
                            <span>Specifications</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.specs,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Free Sms
                                </td>
                                {getRows("free_sms")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Free On Net Minutes
                                </td>
                                {getRows("free_on_net_minutes")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Free Off Net Minutes
                                </td>
                                {getRows("free_off_net_minutes")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Validty
                                </td>
                                {getRows("validity")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Free Mbs
                                </td>
                                {getRows("free_mbs")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="5">
                        <div className="row compare-folding-section">
                          <div className="col-12 text-center">
                            <h2 style={{ fontWeight: "lighter" }}>
                              Select product to start comparing
                            </h2>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ComparePackage;
